export class Color {
    constructor(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a !== undefined ? a : 1;
    }
    rgb() {
        return `rgb(${this.r}, ${this.g}, ${this.b})`;
    }
    rgba(a) {
        if (a !== undefined) {
            this.a = a;
        }
        return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`;
    }
}
